import Session from '../api';
const { api } = Session;

export const usePaywallApi = () => api; // pretty simple hook
